<script lang="ts" setup>

import PayPageDefault from './components/PayPage.default.vue'






import { getPayPageConfig } from '@/composables/payment'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置
const config = getPayPageConfig()

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const PayPage = loadBrandComponent({ rocnovel: PayPageDefault })
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <PayPage :config="config" />
  </div>
</template>
